/**
 * Whether the button must behave as non-clickable.
 * `isLoading` always wins: a loading button is never clickable, regardless of `disabled`.
 *
 * @param {boolean} disabled
 * @param {boolean} isLoading
 * @return {boolean}
 */
export const getIsDisabled = (disabled, isLoading) =>
  Boolean(disabled) || Boolean(isLoading);

/**
 * PropTypes validator for `ariaLabel`. Required only when the button has no visible text
 * (icon-only) — an icon-only button without an accessible name must not go unnoticed.
 *
 * @param {Object} props
 * @param {string} propName
 * @param {string} componentName
 * @return {Error|null}
 */
export const validateAriaLabel = (props, propName, componentName) => {
  const hasVisibleText = Boolean(props.children);
  const value = props[propName];

  if (!hasVisibleText && !value) {
    return new Error(
      `[${componentName}] 'ariaLabel' is required when the button has no visible text ` +
        "(icon-only). Without it, screen reader users can't tell what the button does."
    );
  }

  if (value !== undefined && typeof value !== 'string') {
    return new Error(`[${componentName}] "ariaLabel" must be a string.`);
  }

  return null;
};
